const dev = {
  API_ENDPOINT_URL: 'http://localhost:8080'
};

const prod = {
  API_ENDPOINT_URL: 'https://findit-app-599676018a33.herokuapp.com'
};

const test = {
  API_ENDPOINT_URL: 'https://findit-app-599676018a33.herokuapp.com'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
